export default {
  columnLabels: {
    view: 'View',
    title: 'Title',
    mediaType: 'Type',
    dateCreated: 'Date Created',
    type: 'Preset Type',
    scorecard: 'Scorecard',
    build: 'Build',
    delete: 'Delete'
  }
}
